<template>
  <div id="app">
    <AppHeader v-if="$store.state.Login.userLoggedIn" />
    <div class="content-wrap">
      <RouterView
        v-if="$store.state.Login.userLoggedIn" />
      <Login v-else />
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/Header'
import Login from "@/components/Login.vue";

export default {
  name: 'App',
  components: {
    Login,
    AppHeader
  },
  beforeCreate() {
    const localStorageItem = window.localStorage.getItem("userLoggedIn");
    if (localStorageItem) {
      this.$store.dispatch('LOGIN_USER', {
        isLocalStorage: true,
        localStorageItem
      });
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
#app {
  font-family:$font--base;
  min-height:100%;
  background:$color--base;
  color:$color--white;

  .content-wrap {
    margin: 0 $gutter--base;
    padding-top: var(--header-height, 100px);
    min-height: calc(100vh - var(--header-height, 100px));
    display: flex;
  }

  @include mobile {
    .content-wrap {
      margin: 0 $gutter--base-mbl;
    }
  }
}
</style>
